import React, {Component} from 'react'
import {Container, Row, Col, Card, CardHeader, CardBody, FormGroup, Label, Input, Button} from 'reactstrap'
import classes from './FormRegistartion.module.css'
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css'
import firebase from "../../Config/firebase";
import './FormRegistartion.module.css'
import {v4 as uuidv4} from 'uuid'
import Select from 'react-select'


import ContentLoader from "react-content-loader"
import {MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCol, MDBContainer, MDBRow} from "mdbreact";

import CSVReader from "react-csv-reader";
import {getUID} from "../../Utils/firebaseUtils";

const db = firebase.firestore()
const storageRef = firebase.storage()
/*
 CentralAndWestern = CW
 Eastern = E
 Southern = S
 WanChai = WC
 ShamShuiPo = SSP
 KowloonCity = KC
 KwunTong= KT
 WongTaiSin = WTS
 YauTsimMong = YYM
 Islands = I
 KwaiTsing = KT
 North = N
 SaiKung = SK
 ShaTin = ST
 TaiPo = TP
 TsuenWan = TW
 TuenMun = TM
 YuenLong = YL

*/
const districtsArr = [
    {value: 'CW', label: '中西區'},//
    {value: 'E', label: '東區'},//
    {value: 'S', label: '南區'},//
    {value: 'WC', label: '灣仔區'},//
    {value: 'SSP', label: '深水埗'},//
    {value: 'KC', label: '九龍城區'},//
    {value: 'KT', label: '觀塘區'},//
    {value: 'WTS', label: '黃大仙'},//
    {value: 'YYM', label: '油尖旺區'},//
    {value: 'I', label: '離島區'},//
    {value: 'KT', label: '葵青區'},//
    {value: 'N', label: '北區'},//
    {value: 'SK', label: '西貢區'},//
    {value: 'ST', label: '沙田區'},//
    {value: 'TP', label: '大埔區'},//
    {value: 'TW', label: '荃灣區'},//
    {value: 'TM', label: '屯門區'},//
    {value: 'YL', label: '元朗區'}//

]

const sexArr = [
    {value: 'MF', label: '男女'},
    {value: 'M', label: '男校'},
    {value: 'F', label: '女校'}
]


const langArr = [
    {value: 'EMI', label: '英中'},
    {value: 'CMI', label: '中中'}
]


const religionArr = [
    {value: 'N/A', label: '無'},
    {value: 'TA', label: '道教'},//
    {value: 'CO', label: '孔教'},//
    {value: 'BU ', label: '佛教'},//
    {value: 'IS', label: '回教'},//
    {value: 'CA', label: '天主教'}, //
    {value: 'CH', label: '基督教'},//
    {value: 'CB', label: '儒釋道'}// handle else
]

const schoolTypeArr = [
    {value: 'PRI', label: '私立'},
    {value: 'GOV', label: '官立'},
    {value: 'DIR', label: '直資'},
    {value: 'DEP ', label: '按位津貼'},
    {value: 'FOU', label: '資助'},
]

const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    // transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
};


class FormRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Community: {
                avatar: '',
                communityID: '',
                createDate: new Date(),
                createUseId: '',
                description: '',
                lastModified: new Date(),
                isPublish: true,
                plainName: '',
                title: '',
                titleCHI: '',
                address: '',
                addressCHI: '',
                district: '',
                sex: '',
                religion: '',
                lang: ''

            },
            disable: false,
            loading: false,
            loaded: false,

            isLoadedCSVData: false,
            csvDate: []
        }
    }

    componentDidMount() {

    }


    uploadImageCallBack = (e) => {
        return new Promise(async (resolve, reject) => {
            const file = e.target.files[0]
            const fileName = uuidv4()
            storageRef.ref().child("CommunityAvatar/" + fileName).put(file)
                .then(async snapshot => {

                    const downloadURL = await storageRef.ref().child("CommunityAvatar/" + fileName).getDownloadURL()

                    console.log(downloadURL)
                    resolve({
                        success: true,
                        data: {link: downloadURL}
                    })
                })
        })
    }
    onChangeCommunityID = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                communityID: value.toString().toLowerCase().replace(/[^a-z0-9-]/g, "")
            }
        })
        db.collection("Community").doc(value)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        disable: true

                    })
                } else {

                    this.setState({
                        disable: false
                    })
                }
            }).catch(err => console.log(err))
    }

    onChangeDescription = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                description: value
            }
        })
    }

    onChangeTitle = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                title: value
            }
        })
    }

    onChangeTitleCHI = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                titleCHI: value
            }
        })
    }

    onChangeAddress = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                address: value
            }
        })
    }

    onChangeAddressCHI = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                addressCHI: value
            }
        })
    }
    onChangeDistrict = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                district: value
            }
        })
    }
    onChangeSex = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                sex: value
            }
        })
    }

    onChangeReligion = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                religion: value
            }
        })
    }

    onChangelang = (value) => {
        this.setState({
            Community: {
                ...this.state.Community,
                lang: value
            }
        })
    }
    submitForm = () => {
        let plainName = this.state.Community.title.toLowerCase().replace(/\W/g, "")
        console.log(plainName)
        this.setState({
            Community: {
                ...this.state.Community,
                plainName: plainName
            }

        }, () => {

            const Community = this.state.Community
            db.collection("Community").doc(this.state.Community.communityID)
                .set(Community)
                .then(res => {
                    this.setState({
                            Community: {
                                avatar: '',
                                communityID: '',
                                createDate: new Date(),
                                createUseId: '',
                                description: '',
                                lastModified: new Date(),
                                isPublish: true,
                                plainName: '',
                                title: '',
                                titleCHI: '',
                                lang: ''
                            }
                        }
                        , () => {
                            window.location.reload();
                            alert('submit success')
                        })
                })
                .catch(err => console.log(err))


        })


    }


    handleForce = async (data, fileInfo) => {
        if (data.length >= 1) {
            let newData = []

            let allPromise = []
            data.map((e, index) => {
                allPromise.push(new Promise((resolve, reject) => {
                    console.log(e)
                    let district;
                    district = districtsArr.find(el => el.label === e.district)
                    district = typeof district !== 'undefined' ? district.value : "N/A"

                    let religion;
                    religion = religionArr.find(el => el.label === e.religion)
                    religion = typeof religion !== 'undefined' ? religion.value : "N/A"

                    let sex
                    sex = sexArr.find(el => el.label === e.sex)
                    sex = typeof sex !== 'undefined' ? sex.value : "N/A"

                    let schoolType
                    schoolType = schoolTypeArr.find(el => el.label === e.schoolType)
                    schoolType = typeof schoolType !== 'undefined' ? schoolType.value : "N/A"

                    let lang
                    lang = langArr.find(el => el.label === e.lang)
                    lang = typeof lang !== 'undefined' ? lang.value : "N/A"


                    newData.push({
                        schoolCate: "P", //P
                        addressCHI: typeof e.addressCHI !== 'undefined' ? e.addressCHI : '',
                        address: typeof e.address !== 'undefined' ? e.address : '',
                        avatar: '',
                        communityID: getUID(),
                        createDate: new Date(),
                        createUserId: "",
                        description: "School Description",
                        district: district,
                        isPublish: true,
                        lastModified: new Date(),
                        religion: religion,
                        schoolType: schoolType,
                        lang: lang,
                        sex: sex,
                        tel: typeof e.tel !== 'undefined' && e.tel !== '' ? e.tel : 'N/A',
                        schoolNo: typeof e.schoolNo !== 'undefined' && e.schoolNo !== '' ? e.schoolNo : 'N/A',
                        group: typeof e.group !== 'undefined' && e.group !== '' ? e.group : 'N/A',
                        title: typeof e.title !== 'undefined' ? e.title : '',
                        titleCHI: typeof e.titleCHI !== 'undefined' ? e.titleCHI : ''
                    })

                    resolve()
                }))
            })


            Promise.all(allPromise)
                .then(res => {
                    console.log(newData)
                    this.setState({
                        isLoadedCSVData: true,
                        csvDate: newData
                    })
                })


        }
    };

    submitAllCSVCommunity = () => {
        let allCommunity = this.state.csvDate
        let allPromise = []
        allCommunity.map((e,index) => {
            // if(index === 0 || index === 1 ||index === 2 || index === 3 || index === 4 || index === 5){
                allPromise.push(new Promise((resolve, reject) => {
                    db
                        .collection('Community')
                        .doc(e.communityID)
                        .set(e)
                        .then(res => {

                        })
                        .catch(err => console.log(err))
                }))
            // }

        })

        Promise.all(allPromise)
            .then(res=> {
                console.log('all done!')
            })
    }


    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <CSVReader
                        cssClass="react-csv-input"
                        label={"school csv"}
                        onFileLoaded={this.handleForce}
                        parserOptions={papaparseOptions}
                    />

                    {
                        this.state.isLoadedCSVData ?
                            <MDBBtn color='danger' onClick={() => this.submitAllCSVCommunity()}>
                                Submit CSV Community
                            </MDBBtn>
                            : ''
                    }
                </MDBRow>
                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>

                        <FormGroup>
                            avatarImage
                            {console.log(this.state.Community.avatar)}
                            {this.state.loading && !this.state.loaded ?
                                <ContentLoader
                                    speed={2}
                                    width={340}
                                    height={84}
                                    viewBox="0 0 340 84"
                                    backgroundColor="#333"
                                    foregroundColor="#888"
                                    animate="false"
                                >
                                    <rect x="35" y="13" rx="0" ry="0" width="82" height="68"/>
                                </ContentLoader>
                                : ''
                            }
                            {

                                this.state.hasFeatureImage ?

                                    <img src={this.state.Community.avatar} className={classes.avatarImage}/> : ''
                            }

                            <Input type="file" accept="image/*" className={classes.avatarUploader}
                                   onChange={async (e) => {
                                       const uploadStatus = await this.uploadImageCallBack(e)
                                       this.setState({
                                               loading: true
                                           }, () => {
                                               if (uploadStatus.success) {
                                                   setTimeout(
                                                       () => {
                                                           this.setState({
                                                               loaded: true
                                                           }, () => {
                                                               this.setState({
                                                                   hasFeatureImage: true,
                                                                   Community: {
                                                                       ...this.state.Community,
                                                                       avatar: uploadStatus.data.link
                                                                   },

                                                               })
                                                           })
                                                       }, 1500)

                                               }
                                           }
                                       )

                                   }}>
                            </Input>
                        </FormGroup>
                        {
                            this.state.disable ? "have same id " : ''
                        }
                        <FormGroup>
                            <Label className={classes.communityID}>communityID</Label>
                            <Input type='text' name='communityID' id='communityID' placeholder=''
                                   onChange={(e) => this.onChangeCommunityID(e.target.value)}
                                   value={this.state.Community.communityID}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className={classes.description}>description</Label>
                            <Input type='text' name='description' id='description' placeholder=''
                                   onChange={(e) => this.onChangeDescription(e.target.value)}
                                   value={this.state.Community.description}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className={classes.title}>title</Label>
                            <Input type='text' name='title' id='title' placeholder=''
                                   onChange={(e) => this.onChangeTitle(e.target.value)}
                                   value={this.state.Community.title}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className={classes.titleCHI}>titleCHI</Label>
                            <Input type='text' name='titleCHI' id='titleCHI' placeholder=''
                                   onChange={(e) => this.onChangeTitleCHI(e.target.value)}
                                   value={this.state.Community.titleCHI}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className={classes.address}>address</Label>
                            <Input type='text' name='address' id='address' placeholder=''
                                   onChange={(e) => this.onChangeAddress(e.target.value)}
                                   value={this.state.Community.address}/>
                        </FormGroup>
                        <FormGroup>
                            <Label className={classes.addressCHI}>addressCHI</Label>
                            <Input type='text' name='addressCHI' id='addressCHI' placeholder=''
                                   onChange={(e) => this.onChangeAddressCHI(e.target.value)}
                                   value={this.state.Community.addressCHI}/>
                        </FormGroup>
                        district
                        <Select options={districtsArr}
                                onChange={(e) => this.onChangeDistrict(e.value)}/>
                        Sex
                        <Select options={sexArr}
                                onChange={(e) => this.onChangeSex(e.value)}/>
                        Religion
                        <Select options={religionArr}
                                onChange={(e) => this.onChangeReligion(e.value)}/>
                        lang
                        <Select options={langArr}
                                onChange={(e) => this.onChangelang(e.value)}/>
                        <FormGroup>
                            <button color='danger' disabled={this.state.disable}
                                    onClick={(e) => this.submitForm()}>
                                Submit
                            </button>
                        </FormGroup>
                    </MDBCol>
                </MDBRow>

            </MDBContainer>
        )
    }
}

export default FormRegistration